import React from 'react';
import { Lock, Globe2, ArrowRight, ShieldCheck, Smartphone, Phone, UserRound, Infinity as InfinityIcon, Wrench } from 'lucide-react';
import heroImage from '@/assets/rebrand-travel-hero.png';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const {
    toast
  } = useToast();
  const navigate = useNavigate();

  const scrollToHowItWorks = () => {
    navigate('/how-it-works');
  };

  return (
    <section id="hero" className="rebrand-hero overflow-hidden">
      <div className="rebrand-hero-top">
        <div className="rebrand-hero-visual" aria-label="Remote work beside the sea">
          <img src={heroImage} width="1448" height="1086" loading="eager" fetchPriority="high" decoding="async" alt="Traveller working online beside the sea" />
        </div>

        <div className="rebrand-hero-content">
          <div className="rebrand-hero-copy">
            <div className="rebrand-hero-brand" aria-label="PhantomPath">
              <span className="rebrand-hero-logo" aria-hidden="true" />
              <span>Phantom<span>Path</span></span>
            </div>
            <p className="rebrand-eyebrow">VPN · eSIM DATA · VIRTUAL NUMBERS</p>
            <h1>Always connected.<br />Browse privately.</h1>
            <p className="rebrand-hero-intro">Flexible VPN access, travel eSIM data and UK/USA virtual numbers in one straightforward pay-as-you-go platform. No account sign-up. No ongoing subscriptions.</p>
          </div>

          <div className="rebrand-hero-actions" aria-label="Choose a PhantomPath product">
            <a href="/#vpn-passes">VPN Passes <ArrowRight className="h-4 w-4" /></a>
            <a href="/#esim-data">Travel eSIM Data <ArrowRight className="h-4 w-4" /></a>
            <a href="/#virtual-numbers">Virtual Numbers <ArrowRight className="h-4 w-4" /></a>
          </div>
          <div className="rebrand-upgrade-notice" role="status">
            <span className="rebrand-upgrade-icon" aria-hidden="true"><Wrench /></span>
            <div>
              <strong>Temporary Maintenance &amp; Upgrades</strong>
              <p>All existing PhantomPath access codes remain valid and can continue to be used through the PhantomPath Portal.</p>
              <p>While we carry out essential upgrades, we are temporarily pausing all new purchases.</p>
              <p>Thank you for your patience and understanding. We'll be back soon!</p>
            </div>
          </div>
          <a href="https://portal.phantompathvpn.com/" className="rebrand-portal-link"><Lock className="h-4 w-4" /> PhantomPath Portal</a>
          <p className="rebrand-portal-explainer">Already purchased? Enter your access code in the PhantomPath Portal to activate and manage your service.</p>
          <p className="rebrand-duration">
            <span>1 hour</span>
            <span>24 hours</span>
            <span>7 days</span>
            <span>14 days</span>
            <span>30 days</span>
          </p>
        </div>
      </div>

      <div id="service-options" className="rebrand-product-panel">
        <div className="rebrand-product-heading">
          <div><p>CHOOSE WHAT YOU NEED</p><h2>Everything you need, only when you need it.</h2></div>
          <span>VPN access, travel eSIM data and a separate UK/USA number in one place. Choose what you need, pay once, and manage your service through the PhantomPath Portal.</span>
        </div>
        <div className="rebrand-service-grid">
          <a href="/#vpn-passes">
            <ShieldCheck aria-hidden="true" /><span><strong>VPN Passes</strong><small>Protect your connection on public Wi-Fi, shared networks, or whenever you want a more private internet connection.</small></span><ArrowRight aria-hidden="true" />
          </a>
          <a href="/#esim-data">
            <Smartphone aria-hidden="true" /><span><strong>Travel eSIM Data</strong><small>Get mobile data while travelling without relying on your normal roaming plan.</small></span><ArrowRight aria-hidden="true" />
          </a>
          <a href="/#virtual-numbers">
            <Phone aria-hidden="true" /><span><strong>Virtual Numbers</strong><small>Use a temporary UK or USA number for calls and messaging without needing another physical SIM.</small></span><ArrowRight aria-hidden="true" />
          </a>
        </div>
        <div className="rebrand-trust-row">
          <span><span>×</span>A VPN when you need one</span>
          <span><UserRound aria-hidden="true" />Travel data when you need it</span>
          <span><ShieldCheck aria-hidden="true" />A separate number when you don't want to use your own</span>
          <span><InfinityIcon aria-hidden="true" />Pay once, with no ongoing subscription</span>
        </div>
        <div className="rebrand-panel-footer">
          <button type="button" onClick={scrollToHowItWorks} className="rebrand-how-link">See how PhantomPath works <ArrowRight className="h-4 w-4" /></button>
          <div className="rebrand-international"><Globe2 className="h-4 w-4" /><span>International customers welcome · Prices shown in GBP</span></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
